import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import SectionSeparator from '../../components/SectionSeparator/SectionSeparator';

import { debtorsList } from '@selectors/caseDetails';

import './DebtorsList.scss';

const DebtorList = ({ data }) => (
  <div>
    {data.length > 0 && (
      <React.Fragment>
        <SectionSeparator title="Debtors" />
        <Paper className="debtors-list">
          <Table>
            <TableHead>
              <TableRow className="debtors-list__header">
                <TableCell>Name</TableCell>
                <TableCell>Petition date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(({
                id,
                name,
                petitionDate,
              }) => (
                <TableRow key={id}>
                  <TableCell>{name}</TableCell>
                  <TableCell>{petitionDate && moment(petitionDate).format('L')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </React.Fragment>
    )}
  </div>
);

DebtorList.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    petitionDate: PropTypes.string,
  })).isRequired,
};

const mapStateToProps = state => ({
  data: debtorsList(state),
});

export default connect(mapStateToProps)(DebtorList);



// WEBPACK FOOTER //
// ./src/routes/Case/Details/containers/DebtorsList/DebtorsList.js